var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"staff-loan-audit-tags"},[_vm._l((_vm.tags),function(tag){return _c('span',{key:tag.code,staticClass:"status-tag staff-loan-audit-tags__tag",style:({ backgroundColor: tag.color })},[_vm._v(" "+_vm._s(tag.name)+" ")])}),(!_vm.tags.length)?_c('span',[_vm._v("-")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }